import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import Modal from '../../../components/Modal';
import { Dialog, DialogContent, DialogButton, DialogFooter } from '../../../components/Dialog';
import { Form, Input } from '../../../components/Form';
import styles from './NewTeamModal.m.sass';
var NewTeamModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function NewTeamModal() {
    _classCallCheck(this, NewTeamModal);
    return _callSuper(this, NewTeamModal, arguments);
  }
  _inherits(NewTeamModal, _React$Component);
  return _createClass(NewTeamModal, [{
    key: "render",
    value: function render() {
      var teamManagementStore = this.props.teamManagementStore;
      var newTeamState = teamManagementStore.newTeamState;
      return /*#__PURE__*/React.createElement(Modal, {
        position: "top",
        isOpened: newTeamState.showing,
        onRequestClose: newTeamState.close
      }, /*#__PURE__*/React.createElement(NewTeamEditor, {
        state: newTeamState
      }));
    }
  }]);
}(React.Component)) || _class;
export { NewTeamModal as default };
var NewTeamEditor = observer(function NewTeamEditor(_ref) {
  var state = _ref.state;
  return /*#__PURE__*/React.createElement(Dialog, null, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    className: styles.intro
  }, !state.rootStore.sessionStore.workspace.corporate && /*#__PURE__*/React.createElement("img", {
    className: styles.illustration,
    src: require('./illustration.svg'),
    alt: "Illustration of a group"
  }), /*#__PURE__*/React.createElement("p", {
    className: styles.title
  }, "Create A New Team"), /*#__PURE__*/React.createElement("p", {
    className: styles.description
  }, "Looking to collaborate on work? Create a team to get started!")), /*#__PURE__*/React.createElement("div", {
    className: styles.form
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Input, {
    label: "Team Name",
    field: "name",
    model: state,
    onBlur: state.suggestSlug
  }), /*#__PURE__*/React.createElement(Input, {
    label: "URL Slug",
    help: "This field will indicate your unique identifier within this workspace. Must be alphanumerical including dashes (except at the beginning and end)",
    field: "slug",
    model: state
  })))), /*#__PURE__*/React.createElement(DialogFooter, {
    bordered: true
  }, /*#__PURE__*/React.createElement(DialogButton, {
    onClick: state.close
  }, "Close"), /*#__PURE__*/React.createElement(DialogButton, {
    type: "primary",
    onClick: state.createTeam
  }, "Add")));
});
//# sourceMappingURL=index.js.map
